import React, { useState } from 'react';
import { Tabs, Card } from 'antd';
import {
  DashboardOutlined,
  KeyOutlined,
  CheckCircleOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import LIMSDashboard from './LIMSDashboard';
import APITokensList from './APITokensList';
import SampleConfirmationsList from './SampleConfirmationsList';
import IntegrationLogsList from './IntegrationLogsList';
import ErrorBoundary from './ErrorBoundary';

const { TabPane } = Tabs;

const LIMSIntegration = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [loading, setLoading] = useState(false);

  const tabItems = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: <DashboardOutlined />,
      children: <LIMSDashboard />
    },
    {
      key: 'tokens',
      label: 'API Tokens',
      icon: <KeyOutlined />,
      children: <APITokensList />
    },
    {
      key: 'confirmations',
      label: 'Sample Confirmations',
      icon: <CheckCircleOutlined />,
      children: <SampleConfirmationsList />
    },
    {
      key: 'logs',
      label: 'Integration Logs',
      icon: <FileTextOutlined />,
      children: <IntegrationLogsList />
    }
  ];

  return (
    <ErrorBoundary>
      <div style={{ padding: '24px' }}>
        <Card>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={tabItems}
            size="large"
          />
        </Card>
      </div>
    </ErrorBoundary>
  );
};

export default LIMSIntegration;
